// btw-front/src/api/auth.js
import { api, setAccessToken } from "./client";

// loginId: partner 는 partner_user.login_id, admin 은 admin_user.email 입력값
export async function login(loginId, password) {
  const res = await api.post("/auth/login", { loginId, password });
  if (res && res.accessToken) setAccessToken(res.accessToken);
  return res; // { accessToken, expiresAt, role, profile }
}

export async function logout() {
  try {
    await api.post("/auth/logout");
  } catch (e) {
    /* stateless — 실패해도 무시 */
  }
  setAccessToken(null);
}

// 발송 전 확인용 — 등록 이메일을 마스킹 형태로 조회. 미등록 아이디면 404(USER_NOT_FOUND)
export async function lookupPasswordReset(loginId) {
  return api.post("/auth/password-reset/lookup", { loginId });
}

export async function requestPasswordReset(loginId) {
  return api.post("/auth/password-reset/request", { loginId });
}

export async function confirmPasswordReset(token, newPassword) {
  return api.post("/auth/password-reset/confirm", { token, newPassword });
}
